import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { CfPopoverBase } from 'components/popover-host/popover-interface';
import { PopoverController } from 'providers/popover-controller';
import { SettingsService } from 'services/settings.service';

import { LL } from 'i18n/i18n.service';
@Component({
  selector: 'help-card-popover',
  templateUrl: 'help-card-popover.html',
  standalone: false,
  host: { 'class': 'help-card-popover' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelpCardPopover extends CfPopoverBase {
  protected LL = LL;
  helpId: string;
  header: string = '';

  constructor(
    private settings: SettingsService,
    private cdr: ChangeDetectorRef,
    private popoverCtrl: PopoverController,
  ) {
    super();
  }

  ngOnInit() {
    // mark help as seen
    if (this.helpId) {
      let mySettings = JSON.parse(this.settings.helpSeenJSON || '{}') || {};
      mySettings[this.helpId] = true;
      this.settings.helpSeenJSON = JSON.stringify(mySettings);
    }
  }

  onHeaderChange(title: string) {
    this.header = title;
    this.cdr.markForCheck();
  }

  close() {
    void this.popoverCtrl.dismiss(this);
  }

  onWillDismiss(): void {}
}
